import sortByDate from 'helpers/sortByDate';

export default function sortByDateDateFrom(a, b) {
  return sortByDate(a.dateFrom, b.dateFrom);
}